import { knowledgerApi as api } from "src/datahandling/redux/api/rtkQueryCodeGen/knowledgerApi/knowledgerApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    postApiByCompanyIdActivity: build.mutation<
      PostApiByCompanyIdActivityApiResponse,
      PostApiByCompanyIdActivityApiArg
    >({
      query: (queryArg) => ({
        url: `/api/${queryArg.companyId}/activity`,
        method: "POST",
        body: queryArg.activitySaveWebRequest,
      }),
      extraOptions: {},
    }),
    putApiByCompanyIdActivity: build.mutation<
      PutApiByCompanyIdActivityApiResponse,
      PutApiByCompanyIdActivityApiArg
    >({
      query: (queryArg) => ({
        url: `/api/${queryArg.companyId}/activity`,
        method: "PUT",
        body: queryArg.activitySaveWebRequest,
      }),
      extraOptions: {},
    }),
    completed: build.mutation<CompletedApiResponse, CompletedApiArg>({
      query: (queryArg) => ({
        url: `/api/${queryArg.companyId}/activity/complete`,
        method: "PATCH",
        body: queryArg.activitySetStatusWebRequest,
      }),
      extraOptions: {},
    }),
    canceled: build.mutation<CanceledApiResponse, CanceledApiArg>({
      query: (queryArg) => ({
        url: `/api/${queryArg.companyId}/activity/cancel`,
        method: "PATCH",
        body: queryArg.activitySetStatusWebRequest,
      }),
      extraOptions: {},
    }),
    started: build.mutation<StartedApiResponse, StartedApiArg>({
      query: (queryArg) => ({
        url: `/api/${queryArg.companyId}/activity/start`,
        method: "PATCH",
        body: queryArg.activitySetStatusWebRequest,
      }),
      extraOptions: {},
    }),
    getApiByCompanyIdActivityAndIdPartitionKey: build.query<
      GetApiByCompanyIdActivityAndIdPartitionKeyApiResponse,
      GetApiByCompanyIdActivityAndIdPartitionKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/${queryArg.companyId}/activity/${queryArg.id}/${queryArg.partitionKey}`,
      }),
      extraOptions: {},
    }),
    deleteApiByCompanyIdActivityAndIdPartitionKey: build.mutation<
      DeleteApiByCompanyIdActivityAndIdPartitionKeyApiResponse,
      DeleteApiByCompanyIdActivityAndIdPartitionKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/${queryArg.companyId}/activity/${queryArg.id}/${queryArg.partitionKey}`,
        method: "DELETE",
      }),
      extraOptions: {},
    }),
    getApiByCompanyIdActivityList: build.query<
      GetApiByCompanyIdActivityListApiResponse,
      GetApiByCompanyIdActivityListApiArg
    >({
      query: (queryArg) => ({
        url: `/api/${queryArg.companyId}/activity/list`,
        params: {
          siteIds: queryArg.siteIds,
          statuses: queryArg.statuses,
          from: queryArg["from"],
          to: queryArg.to,
        },
      }),
      extraOptions: {},
    }),
    postApiAggregateUnit: build.mutation<
      PostApiAggregateUnitApiResponse,
      PostApiAggregateUnitApiArg
    >({
      query: (queryArg) => ({
        url: `/api/aggregate/unit`,
        method: "POST",
        body: queryArg.aggregateGetIotUnitWebRequest,
      }),
      extraOptions: {},
    }),
    postApiAggregateMultiType: build.mutation<
      PostApiAggregateMultiTypeApiResponse,
      PostApiAggregateMultiTypeApiArg
    >({
      query: (queryArg) => ({
        url: `/api/aggregate/multi-type`,
        method: "POST",
        body: queryArg.aggregateGetIotUnitWebRequest,
      }),
      extraOptions: {},
    }),
    getApiByCompanyIdChartEvents: build.query<
      GetApiByCompanyIdChartEventsApiResponse,
      GetApiByCompanyIdChartEventsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/${queryArg.companyId}/chart/events`,
        params: {
          siteIds: queryArg.siteIds,
          from: queryArg["from"],
          to: queryArg.to,
          include: queryArg.include,
        },
      }),
      extraOptions: {},
    }),
    deleteApiByCompanyIdCommentAndIdPartitionKey: build.mutation<
      DeleteApiByCompanyIdCommentAndIdPartitionKeyApiResponse,
      DeleteApiByCompanyIdCommentAndIdPartitionKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/${queryArg.companyId}/comment/${queryArg.id}/${queryArg.partitionKey}`,
        method: "DELETE",
      }),
      extraOptions: {},
    }),
    getApiByCompanyIdCommentAndIdPartitionKey: build.query<
      GetApiByCompanyIdCommentAndIdPartitionKeyApiResponse,
      GetApiByCompanyIdCommentAndIdPartitionKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/${queryArg.companyId}/comment/${queryArg.id}/${queryArg.partitionKey}`,
      }),
      extraOptions: {},
    }),
    postApiByCompanyIdComment: build.mutation<
      PostApiByCompanyIdCommentApiResponse,
      PostApiByCompanyIdCommentApiArg
    >({
      query: (queryArg) => ({
        url: `/api/${queryArg.companyId}/comment`,
        method: "POST",
        body: queryArg.commentCreateWebRequest,
      }),
      extraOptions: {},
    }),
    putApiByCompanyIdComment: build.mutation<
      PutApiByCompanyIdCommentApiResponse,
      PutApiByCompanyIdCommentApiArg
    >({
      query: (queryArg) => ({
        url: `/api/${queryArg.companyId}/comment`,
        method: "PUT",
        body: queryArg.commentUpdateWebRequest,
      }),
      extraOptions: {},
    }),
    patchApiByCompanyIdCompanySettings: build.mutation<
      PatchApiByCompanyIdCompanySettingsApiResponse,
      PatchApiByCompanyIdCompanySettingsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/${queryArg.companyId}/company-settings`,
        method: "PATCH",
        body: queryArg.companySettingsSaveWebRequest,
      }),
      extraOptions: {},
    }),
    getApiByCompanyIdCompanySettings: build.query<
      GetApiByCompanyIdCompanySettingsApiResponse,
      GetApiByCompanyIdCompanySettingsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/${queryArg.companyId}/company-settings`,
      }),
      extraOptions: {},
    }),
    getApiByCompanyIdDailyLogAndIdPartitionKey: build.query<
      GetApiByCompanyIdDailyLogAndIdPartitionKeyApiResponse,
      GetApiByCompanyIdDailyLogAndIdPartitionKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/${queryArg.companyId}/daily-log/${queryArg.id}/${queryArg.partitionKey}`,
      }),
      extraOptions: {},
    }),
    deleteApiByCompanyIdDailyLogAndIdPartitionKey: build.mutation<
      DeleteApiByCompanyIdDailyLogAndIdPartitionKeyApiResponse,
      DeleteApiByCompanyIdDailyLogAndIdPartitionKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/${queryArg.companyId}/daily-log/${queryArg.id}/${queryArg.partitionKey}`,
        method: "DELETE",
      }),
      extraOptions: {},
    }),
    postApiByCompanyIdDailyLog: build.mutation<
      PostApiByCompanyIdDailyLogApiResponse,
      PostApiByCompanyIdDailyLogApiArg
    >({
      query: (queryArg) => ({
        url: `/api/${queryArg.companyId}/daily-log`,
        method: "POST",
        body: queryArg.dailyLogSaveWebRequest,
      }),
      extraOptions: {},
    }),
    putApiByCompanyIdDailyLog: build.mutation<
      PutApiByCompanyIdDailyLogApiResponse,
      PutApiByCompanyIdDailyLogApiArg
    >({
      query: (queryArg) => ({
        url: `/api/${queryArg.companyId}/daily-log`,
        method: "PUT",
        body: queryArg.dailyLogSaveWebRequest,
      }),
      extraOptions: {},
    }),
    deleteApiByCompanyIdDailyLog: build.mutation<
      DeleteApiByCompanyIdDailyLogApiResponse,
      DeleteApiByCompanyIdDailyLogApiArg
    >({
      query: (queryArg) => ({
        url: `/api/${queryArg.companyId}/daily-log`,
        method: "DELETE",
        params: {
          ids: queryArg.ids,
        },
      }),
      extraOptions: {},
    }),
    getApiByCompanyIdDailyLogList: build.query<
      GetApiByCompanyIdDailyLogListApiResponse,
      GetApiByCompanyIdDailyLogListApiArg
    >({
      query: (queryArg) => ({
        url: `/api/${queryArg.companyId}/daily-log/list`,
        params: {
          siteIds: queryArg.siteIds,
          from: queryArg["from"],
          to: queryArg.to,
        },
      }),
      extraOptions: {},
    }),
    postApiByCompanyIdDeviation: build.mutation<
      PostApiByCompanyIdDeviationApiResponse,
      PostApiByCompanyIdDeviationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/${queryArg.companyId}/deviation`,
        method: "POST",
        body: queryArg.deviationSaveWebRequest,
      }),
      extraOptions: {},
    }),
    putApiByCompanyIdDeviation: build.mutation<
      PutApiByCompanyIdDeviationApiResponse,
      PutApiByCompanyIdDeviationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/${queryArg.companyId}/deviation`,
        method: "PUT",
        body: queryArg.deviationSaveWebRequest,
      }),
      extraOptions: {},
    }),
    patchApiByCompanyIdDeviationResolve: build.mutation<
      PatchApiByCompanyIdDeviationResolveApiResponse,
      PatchApiByCompanyIdDeviationResolveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/${queryArg.companyId}/deviation/resolve`,
        method: "PATCH",
        body: queryArg.deviationResolveWebRequest,
      }),
      extraOptions: {},
    }),
    getApiByCompanyIdDeviationAndIdPartitionKey: build.query<
      GetApiByCompanyIdDeviationAndIdPartitionKeyApiResponse,
      GetApiByCompanyIdDeviationAndIdPartitionKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/${queryArg.companyId}/deviation/${queryArg.id}/${queryArg.partitionKey}`,
      }),
      extraOptions: {},
    }),
    deleteApiByCompanyIdDeviationAndIdPartitionKey: build.mutation<
      DeleteApiByCompanyIdDeviationAndIdPartitionKeyApiResponse,
      DeleteApiByCompanyIdDeviationAndIdPartitionKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/${queryArg.companyId}/deviation/${queryArg.id}/${queryArg.partitionKey}`,
        method: "DELETE",
      }),
      extraOptions: {},
    }),
    getApiByCompanyIdDeviationList: build.query<
      GetApiByCompanyIdDeviationListApiResponse,
      GetApiByCompanyIdDeviationListApiArg
    >({
      query: (queryArg) => ({
        url: `/api/${queryArg.companyId}/deviation/list`,
        params: {
          siteIds: queryArg.siteIds,
          resolved: queryArg.resolved,
          severities: queryArg.severities,
          from: queryArg["from"],
          to: queryArg.to,
        },
      }),
      extraOptions: {},
    }),
    getApiByCompanyIdEquipmentDevices: build.query<
      GetApiByCompanyIdEquipmentDevicesApiResponse,
      GetApiByCompanyIdEquipmentDevicesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/${queryArg.companyId}/equipment/devices`,
      }),
      extraOptions: {},
    }),
    deleteApiByCompanyIdFeedLossAndIdPartitionKey: build.mutation<
      DeleteApiByCompanyIdFeedLossAndIdPartitionKeyApiResponse,
      DeleteApiByCompanyIdFeedLossAndIdPartitionKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/${queryArg.companyId}/feed-loss/${queryArg.id}/${queryArg.partitionKey}`,
        method: "DELETE",
      }),
      extraOptions: {},
    }),
    getApiByCompanyIdFeedLossAndIdPartitionKey: build.query<
      GetApiByCompanyIdFeedLossAndIdPartitionKeyApiResponse,
      GetApiByCompanyIdFeedLossAndIdPartitionKeyApiArg
    >({
      query: (queryArg) => ({
        url: `/api/${queryArg.companyId}/feed-loss/${queryArg.id}/${queryArg.partitionKey}`,
      }),
      extraOptions: {},
    }),
    putApiByCompanyIdFeedPlan: build.mutation<
      PutApiByCompanyIdFeedPlanApiResponse,
      PutApiByCompanyIdFeedPlanApiArg
    >({
      query: (queryArg) => ({
        url: `/api/${queryArg.companyId}/feed-plan`,
        method: "PUT",
        body: queryArg.feedPlanSaveWebRequest,
      }),
      extraOptions: {},
    }),
    getApiByCompanyIdFeedPlanList: build.query<
      GetApiByCompanyIdFeedPlanListApiResponse,
      GetApiByCompanyIdFeedPlanListApiArg
    >({
      query: (queryArg) => ({
        url: `/api/${queryArg.companyId}/feed-plan/list`,
        params: {
          siteIds: queryArg.siteIds,
          from: queryArg["from"],
          to: queryArg.to,
          sources: queryArg.sources,
        },
      }),
      extraOptions: {},
    }),
    postApiByCompanyIdFeedPlanDay: build.mutation<
      PostApiByCompanyIdFeedPlanDayApiResponse,
      PostApiByCompanyIdFeedPlanDayApiArg
    >({
      query: (queryArg) => ({
        url: `/api/${queryArg.companyId}/feed-plan/day`,
        method: "POST",
        body: queryArg.feedPlanGetDailyBySitesWebRequest,
      }),
      extraOptions: {},
    }),
    getApiByCompanyIdFishTraceProjects: build.query<
      GetApiByCompanyIdFishTraceProjectsApiResponse,
      GetApiByCompanyIdFishTraceProjectsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/${queryArg.companyId}/fish-trace/projects`,
      }),
      extraOptions: {},
    }),
    getApiByCompanyIdFishTraceProjectAndProjectId: build.query<
      GetApiByCompanyIdFishTraceProjectAndProjectIdApiResponse,
      GetApiByCompanyIdFishTraceProjectAndProjectIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/${queryArg.companyId}/fish-trace/project/${queryArg.projectId}`,
      }),
      extraOptions: {},
    }),
    getApiByCompanyIdFishTraceAssembledContentAndPopulationId: build.query<
      GetApiByCompanyIdFishTraceAssembledContentAndPopulationIdApiResponse,
      GetApiByCompanyIdFishTraceAssembledContentAndPopulationIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/${queryArg.companyId}/fish-trace/assembled-content/${queryArg.populationId}`,
      }),
      extraOptions: {},
    }),
    getApiByCompanyIdFishTraceUnitsWithDataAndSiteIdDate: build.query<
      GetApiByCompanyIdFishTraceUnitsWithDataAndSiteIdDateApiResponse,
      GetApiByCompanyIdFishTraceUnitsWithDataAndSiteIdDateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/${queryArg.companyId}/fish-trace/units-with-data/${queryArg.siteId}/${queryArg.date}`,
      }),
      extraOptions: {},
    }),
    getApiByCompanyIdFishTraceProjectRangeAndProjectId: build.query<
      GetApiByCompanyIdFishTraceProjectRangeAndProjectIdApiResponse,
      GetApiByCompanyIdFishTraceProjectRangeAndProjectIdApiArg
    >({
      query: (queryArg) => ({
        url: `/api/${queryArg.companyId}/fish-trace/project-range/${queryArg.projectId}`,
      }),
      extraOptions: {},
    }),
    getApiByCompanyIdFishTraceAssembledContentAndFarmerSiteIdUnitIdDate:
      build.query<
        GetApiByCompanyIdFishTraceAssembledContentAndFarmerSiteIdUnitIdDateApiResponse,
        GetApiByCompanyIdFishTraceAssembledContentAndFarmerSiteIdUnitIdDateApiArg
      >({
        query: (queryArg) => ({
          url: `/api/${queryArg.companyId}/fish-trace/assembled-content/${queryArg.farmerSiteId}/${queryArg.unitId}/${queryArg.date}`,
        }),
        extraOptions: {},
      }),
    getApiByCompanyIdFishTraceAssembledProjectAndProjectIdDate: build.query<
      GetApiByCompanyIdFishTraceAssembledProjectAndProjectIdDateApiResponse,
      GetApiByCompanyIdFishTraceAssembledProjectAndProjectIdDateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/${queryArg.companyId}/fish-trace/assembled-project/${queryArg.projectId}/${queryArg.date}`,
        params: {
          fishgroup: queryArg.fishgroup,
        },
      }),
      extraOptions: {},
    }),
    getApiByCompanyIdFishTraceAssembledSiteAndFarmerSiteIdDate: build.query<
      GetApiByCompanyIdFishTraceAssembledSiteAndFarmerSiteIdDateApiResponse,
      GetApiByCompanyIdFishTraceAssembledSiteAndFarmerSiteIdDateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/${queryArg.companyId}/fish-trace/assembled-site/${queryArg.farmerSiteId}/${queryArg.date}`,
        params: {
          fishgroup: queryArg.fishgroup,
        },
      }),
      extraOptions: {},
    }),
    getApiByCompanyIdFishTraceAssembledUnitAndFarmerUnitIdDate: build.query<
      GetApiByCompanyIdFishTraceAssembledUnitAndFarmerUnitIdDateApiResponse,
      GetApiByCompanyIdFishTraceAssembledUnitAndFarmerUnitIdDateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/${queryArg.companyId}/fish-trace/assembled-unit/${queryArg.farmerUnitId}/${queryArg.date}`,
        params: {
          fishgroup: queryArg.fishgroup,
        },
      }),
      extraOptions: {},
    }),
    getApiByCompanyIdFishTraceFishgroups: build.query<
      GetApiByCompanyIdFishTraceFishgroupsApiResponse,
      GetApiByCompanyIdFishTraceFishgroupsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/${queryArg.companyId}/fish-trace/fishgroups`,
      }),
      extraOptions: {},
    }),
    getApiByCompanyIdFishTraceFishgroupsAndGeneration: build.query<
      GetApiByCompanyIdFishTraceFishgroupsAndGenerationApiResponse,
      GetApiByCompanyIdFishTraceFishgroupsAndGenerationApiArg
    >({
      query: (queryArg) => ({
        url: `/api/${queryArg.companyId}/fish-trace/fishgroups/${queryArg.generation}`,
      }),
      extraOptions: {},
    }),
    getApiByCompanyIdFishTraceSites: build.query<
      GetApiByCompanyIdFishTraceSitesApiResponse,
      GetApiByCompanyIdFishTraceSitesApiArg
    >({
      query: (queryArg) => ({
        url: `/api/${queryArg.companyId}/fish-trace/sites`,
      }),
      extraOptions: {},
    }),
    getApiByCompanyIdFishTraceUnits: build.query<
      GetApiByCompanyIdFishTraceUnitsApiResponse,
      GetApiByCompanyIdFishTraceUnitsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/${queryArg.companyId}/fish-trace/units`,
      }),
      extraOptions: {},
    }),
    postApiByCompanyIdInsightsHistoricalData: build.mutation<
      PostApiByCompanyIdInsightsHistoricalDataApiResponse,
      PostApiByCompanyIdInsightsHistoricalDataApiArg
    >({
      query: (queryArg) => ({
        url: `/api/${queryArg.companyId}/insights/historical-data`,
        method: "POST",
        body: queryArg.insightsGetHistoricWebRequest,
      }),
      extraOptions: {},
    }),
    postApiByCompanyIdInsightsActivitiesStats: build.mutation<
      PostApiByCompanyIdInsightsActivitiesStatsApiResponse,
      PostApiByCompanyIdInsightsActivitiesStatsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/${queryArg.companyId}/insights/activities/stats`,
        method: "POST",
        body: queryArg.insightsGetCountStatsWebRequest,
      }),
      extraOptions: {},
    }),
    postApiByCompanyIdInsightsDeviationsStats: build.mutation<
      PostApiByCompanyIdInsightsDeviationsStatsApiResponse,
      PostApiByCompanyIdInsightsDeviationsStatsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/${queryArg.companyId}/insights/deviations/stats`,
        method: "POST",
        body: queryArg.insightsGetCountStatsWebRequest,
      }),
      extraOptions: {},
    }),
    getApiMealList: build.query<
      GetApiMealListApiResponse,
      GetApiMealListApiArg
    >({
      query: (queryArg) => ({
        url: `/api/meal/list`,
        params: {
          from: queryArg["from"],
          to: queryArg.to,
          siteIds: queryArg.siteIds,
          unitIds: queryArg.unitIds,
          bucketSize: queryArg.bucketSize,
        },
      }),
      extraOptions: {},
    }),
    putApiByCompanyIdUserSettings: build.mutation<
      PutApiByCompanyIdUserSettingsApiResponse,
      PutApiByCompanyIdUserSettingsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/${queryArg.companyId}/user-settings`,
        method: "PUT",
        body: queryArg.userSettingsSaveWebRequest,
      }),
      extraOptions: {},
    }),
    getApiByCompanyIdUserSettings: build.query<
      GetApiByCompanyIdUserSettingsApiResponse,
      GetApiByCompanyIdUserSettingsApiArg
    >({
      query: (queryArg) => ({
        url: `/api/${queryArg.companyId}/user-settings`,
      }),
      extraOptions: {},
    }),

  }),
  overrideExisting: false,
});
export { injectedRtkApi as knowledgerApi };
export type PostApiByCompanyIdActivityApiResponse =
  /** status 200 OK */ ActivityWeb;
export type PostApiByCompanyIdActivityApiArg = {
  companyId: string;
  activitySaveWebRequest: ActivitySaveWebRequest;
};
export type PutApiByCompanyIdActivityApiResponse =
  /** status 200 OK */ ActivityWeb;
export type PutApiByCompanyIdActivityApiArg = {
  companyId: string;
  activitySaveWebRequest: ActivitySaveWebRequest;
};
export type CompletedApiResponse = /** status 200 OK */ ActivityWeb;
export type CompletedApiArg = {
  companyId: string;
  activitySetStatusWebRequest: ActivitySetStatusWebRequest;
};
export type CanceledApiResponse = /** status 200 OK */ ActivityWeb;
export type CanceledApiArg = {
  companyId: string;
  activitySetStatusWebRequest: ActivitySetStatusWebRequest;
};
export type StartedApiResponse = /** status 200 OK */ ActivityWeb;
export type StartedApiArg = {
  companyId: string;
  activitySetStatusWebRequest: ActivitySetStatusWebRequest;
};
export type GetApiByCompanyIdActivityAndIdPartitionKeyApiResponse =
  /** status 200 OK */ ActivityWeb;
export type GetApiByCompanyIdActivityAndIdPartitionKeyApiArg = {
  companyId: string;
  id: string;
  partitionKey: string;
};
export type DeleteApiByCompanyIdActivityAndIdPartitionKeyApiResponse = unknown;
export type DeleteApiByCompanyIdActivityAndIdPartitionKeyApiArg = {
  companyId: string;
  id: string;
  partitionKey: string;
};
export type GetApiByCompanyIdActivityListApiResponse =
  /** status 200 OK */ ActivityWeb[];
export type GetApiByCompanyIdActivityListApiArg = {
  companyId: string;
  siteIds: number[];
  statuses?: StatusWeb[];
  from?: string;
  to?: string;
};
export type PostApiAggregateUnitApiResponse =
  /** status 200 OK */ IotMultiUnitAggregateWeb[];
export type PostApiAggregateUnitApiArg = {
  aggregateGetIotUnitWebRequest: AggregateGetIotUnitWebRequest;
};
export type PostApiAggregateMultiTypeApiResponse =
  /** status 200 OK */ IotMultiTypeAggregateWeb[];
export type PostApiAggregateMultiTypeApiArg = {
  aggregateGetIotUnitWebRequest: AggregateGetIotUnitWebRequest;
};
export type GetApiByCompanyIdChartEventsApiResponse =
  /** status 200 OK */ SiteEventsChartWeb[];
export type GetApiByCompanyIdChartEventsApiArg = {
  companyId: string;
  siteIds: number[];
  from: string;
  to: string;
  include: string[];
};
export type DeleteApiByCompanyIdCommentAndIdPartitionKeyApiResponse = unknown;
export type DeleteApiByCompanyIdCommentAndIdPartitionKeyApiArg = {
  companyId: string;
  id: string;
  partitionKey: string;
};
export type GetApiByCompanyIdCommentAndIdPartitionKeyApiResponse =
  /** status 200 OK */ CommentWeb;
export type GetApiByCompanyIdCommentAndIdPartitionKeyApiArg = {
  companyId: string;
  id: string;
  partitionKey: string;
};
export type PostApiByCompanyIdCommentApiResponse =
  /** status 200 OK */ CommentWeb;
export type PostApiByCompanyIdCommentApiArg = {
  companyId: string;
  commentCreateWebRequest: CommentCreateWebRequest;
};
export type PutApiByCompanyIdCommentApiResponse =
  /** status 200 OK */ CommentWeb;
export type PutApiByCompanyIdCommentApiArg = {
  companyId: string;
  commentUpdateWebRequest: CommentUpdateWebRequest;
};
export type PatchApiByCompanyIdCompanySettingsApiResponse =
  /** status 200 OK */ CompanySettingsWeb;
export type PatchApiByCompanyIdCompanySettingsApiArg = {
  companyId: string;
  companySettingsSaveWebRequest: CompanySettingsSaveWebRequest;
};
export type GetApiByCompanyIdCompanySettingsApiResponse =
  /** status 200 OK */ CompanySettingsWeb;
export type GetApiByCompanyIdCompanySettingsApiArg = {
  companyId: string;
};
export type GetApiByCompanyIdDailyLogAndIdPartitionKeyApiResponse =
  /** status 200 OK */ DailyLogWeb;
export type GetApiByCompanyIdDailyLogAndIdPartitionKeyApiArg = {
  companyId: string;
  id: string;
  partitionKey: string;
};
export type DeleteApiByCompanyIdDailyLogAndIdPartitionKeyApiResponse = unknown;
export type DeleteApiByCompanyIdDailyLogAndIdPartitionKeyApiArg = {
  companyId: string;
  id: string;
  partitionKey: string;
};
export type PostApiByCompanyIdDailyLogApiResponse =
  /** status 200 OK */ DailyLogWeb;
export type PostApiByCompanyIdDailyLogApiArg = {
  companyId: string;
  dailyLogSaveWebRequest: DailyLogSaveWebRequest;
};
export type PutApiByCompanyIdDailyLogApiResponse =
  /** status 200 OK */ DailyLogWeb;
export type PutApiByCompanyIdDailyLogApiArg = {
  companyId: string;
  dailyLogSaveWebRequest: DailyLogSaveWebRequest;
};
export type DeleteApiByCompanyIdDailyLogApiResponse = unknown;
export type DeleteApiByCompanyIdDailyLogApiArg = {
  companyId: string;
  ids?: string[];
};
export type GetApiByCompanyIdDailyLogListApiResponse =
  /** status 200 OK */ DailyLogWeb[];
export type GetApiByCompanyIdDailyLogListApiArg = {
  companyId: string;
  siteIds: number[];
  from?: string;
  to?: string;
};
export type PostApiByCompanyIdDeviationApiResponse =
  /** status 200 OK */ DeviationWeb;
export type PostApiByCompanyIdDeviationApiArg = {
  companyId: string;
  deviationSaveWebRequest: DeviationSaveWebRequest;
};
export type PutApiByCompanyIdDeviationApiResponse =
  /** status 200 OK */ DeviationWeb;
export type PutApiByCompanyIdDeviationApiArg = {
  companyId: string;
  deviationSaveWebRequest: DeviationSaveWebRequest;
};
export type PatchApiByCompanyIdDeviationResolveApiResponse =
  /** status 200 OK */ DeviationWeb;
export type PatchApiByCompanyIdDeviationResolveApiArg = {
  companyId: string;
  deviationResolveWebRequest: DeviationResolveWebRequest;
};
export type GetApiByCompanyIdDeviationAndIdPartitionKeyApiResponse =
  /** status 200 OK */ DeviationWeb;
export type GetApiByCompanyIdDeviationAndIdPartitionKeyApiArg = {
  companyId: string;
  id: string;
  partitionKey: string;
};
export type DeleteApiByCompanyIdDeviationAndIdPartitionKeyApiResponse = unknown;
export type DeleteApiByCompanyIdDeviationAndIdPartitionKeyApiArg = {
  companyId: string;
  id: string;
  partitionKey: string;
};
export type GetApiByCompanyIdDeviationListApiResponse =
  /** status 200 OK */ DeviationWeb[];
export type GetApiByCompanyIdDeviationListApiArg = {
  companyId: string;
  siteIds: number[];
  resolved?: boolean;
  severities?: SeverityWeb[];
  from?: string;
  to?: string;
};
export type GetApiByCompanyIdEquipmentDevicesApiResponse =
  /** status 200 OK */ DeviceWeb[];
export type GetApiByCompanyIdEquipmentDevicesApiArg = {
  companyId: string;
};
export type DeleteApiByCompanyIdFeedLossAndIdPartitionKeyApiResponse = unknown;
export type DeleteApiByCompanyIdFeedLossAndIdPartitionKeyApiArg = {
  companyId: string;
  id: string;
  partitionKey: string;
};
export type GetApiByCompanyIdFeedLossAndIdPartitionKeyApiResponse =
  /** status 200 OK */ FeedLossWeb;
export type GetApiByCompanyIdFeedLossAndIdPartitionKeyApiArg = {
  companyId: string;
  id: string;
  partitionKey: string;
};
export type PutApiByCompanyIdFeedPlanApiResponse =
  /** status 200 OK */ FeedPlanSitePlanWeb;
export type PutApiByCompanyIdFeedPlanApiArg = {
  companyId: string;
  feedPlanSaveWebRequest: FeedPlanSaveWebRequest;
};
export type GetApiByCompanyIdFeedPlanListApiResponse =
  /** status 200 OK */ FeedPlanSitePlanWeb[];
export type GetApiByCompanyIdFeedPlanListApiArg = {
  companyId: string;
  siteIds: number[];
  from: string;
  to: string;
  sources: FeedPlanSourceWeb[];
};
export type PostApiByCompanyIdFeedPlanDayApiResponse =
  /** status 200 OK */ FeedPlanDailyWeb[];
export type PostApiByCompanyIdFeedPlanDayApiArg = {
  companyId: string;
  feedPlanGetDailyBySitesWebRequest: FeedPlanGetDailyBySitesWebRequest;
};
export type GetApiByCompanyIdFishTraceProjectsApiResponse =
  /** status 200 OK */ FishtraceSlimProjectWeb[];
export type GetApiByCompanyIdFishTraceProjectsApiArg = {
  companyId: string;
};
export type GetApiByCompanyIdFishTraceProjectAndProjectIdApiResponse =
  /** status 200 OK */ FishtraceProjectWeb;
export type GetApiByCompanyIdFishTraceProjectAndProjectIdApiArg = {
  companyId: string;
  projectId: number;
};
export type GetApiByCompanyIdFishTraceAssembledContentAndPopulationIdApiResponse =
  /** status 200 OK */ FishtraceWeb;
export type GetApiByCompanyIdFishTraceAssembledContentAndPopulationIdApiArg = {
  companyId: string;
  populationId: number;
};
export type GetApiByCompanyIdFishTraceUnitsWithDataAndSiteIdDateApiResponse =
  /** status 200 OK */ number[];
export type GetApiByCompanyIdFishTraceUnitsWithDataAndSiteIdDateApiArg = {
  companyId: string;
  siteId: number;
  date: string;
};
export type GetApiByCompanyIdFishTraceProjectRangeAndProjectIdApiResponse =
  /** status 200 OK */ FishtraceProjectRangeWeb;
export type GetApiByCompanyIdFishTraceProjectRangeAndProjectIdApiArg = {
  companyId: string;
  projectId: number;
};
export type GetApiByCompanyIdFishTraceAssembledContentAndFarmerSiteIdUnitIdDateApiResponse =
  /** status 200 OK */ FishtraceWeb;
export type GetApiByCompanyIdFishTraceAssembledContentAndFarmerSiteIdUnitIdDateApiArg =
  {
    companyId: string;
    farmerSiteId: number;
    unitId: number;
    date: string;
  };
export type GetApiByCompanyIdFishTraceAssembledProjectAndProjectIdDateApiResponse =
  /** status 200 OK */ FishtraceWeb;
export type GetApiByCompanyIdFishTraceAssembledProjectAndProjectIdDateApiArg = {
  companyId: string;
  projectId: number;
  date: string;
  fishgroup?: string;
};
export type GetApiByCompanyIdFishTraceAssembledSiteAndFarmerSiteIdDateApiResponse =
  /** status 200 OK */ FishtraceWeb;
export type GetApiByCompanyIdFishTraceAssembledSiteAndFarmerSiteIdDateApiArg = {
  companyId: string;
  farmerSiteId: number;
  date: string;
  fishgroup?: string;
};
export type GetApiByCompanyIdFishTraceAssembledUnitAndFarmerUnitIdDateApiResponse =
  /** status 200 OK */ FishtraceWeb;
export type GetApiByCompanyIdFishTraceAssembledUnitAndFarmerUnitIdDateApiArg = {
  companyId: string;
  farmerUnitId: number;
  date: string;
  fishgroup?: string;
};
export type GetApiByCompanyIdFishTraceFishgroupsApiResponse =
  /** status 200 OK */ FishtraceFishgroupWeb[];
export type GetApiByCompanyIdFishTraceFishgroupsApiArg = {
  companyId: string;
};
export type GetApiByCompanyIdFishTraceFishgroupsAndGenerationApiResponse =
  /** status 200 OK */ FishtraceFishgroupWeb[];
export type GetApiByCompanyIdFishTraceFishgroupsAndGenerationApiArg = {
  companyId: string;
  generation: number;
};
export type GetApiByCompanyIdFishTraceSitesApiResponse =
  /** status 200 OK */ FishtraceSiteWeb[];
export type GetApiByCompanyIdFishTraceSitesApiArg = {
  companyId: string;
};
export type GetApiByCompanyIdFishTraceUnitsApiResponse =
  /** status 200 OK */ FishtraceUnitWeb[];
export type GetApiByCompanyIdFishTraceUnitsApiArg = {
  companyId: string;
};
export type PostApiByCompanyIdInsightsHistoricalDataApiResponse =
  /** status 200 OK */ HistoricalDataWeb;
export type PostApiByCompanyIdInsightsHistoricalDataApiArg = {
  companyId: string;
  insightsGetHistoricWebRequest: InsightsGetHistoricWebRequest;
};
export type PostApiByCompanyIdInsightsActivitiesStatsApiResponse =
  /** status 200 OK */ ActionCountStatsWeb;
export type PostApiByCompanyIdInsightsActivitiesStatsApiArg = {
  companyId: string;
  insightsGetCountStatsWebRequest: InsightsGetCountStatsWebRequest;
};
export type PostApiByCompanyIdInsightsDeviationsStatsApiResponse =
  /** status 200 OK */ ActionCountStatsWeb;
export type PostApiByCompanyIdInsightsDeviationsStatsApiArg = {
  companyId: string;
  insightsGetCountStatsWebRequest: InsightsGetCountStatsWebRequest;
};
export type GetApiMealListApiResponse = /** status 200 OK */ MealWeb[];
export type GetApiMealListApiArg = {
  from: string;
  to: string;
  siteIds: number[];
  unitIds?: number[];
  bucketSize?: string;
};
export type PutApiByCompanyIdUserSettingsApiResponse =
  /** status 200 OK */ UserSettingsWeb;
export type PutApiByCompanyIdUserSettingsApiArg = {
  companyId: string;
  userSettingsSaveWebRequest: UserSettingsSaveWebRequest;
};
export type GetApiByCompanyIdUserSettingsApiResponse =
  /** status 200 OK */ UserSettingsWeb;
export type GetApiByCompanyIdUserSettingsApiArg = {
  companyId: string;
};
export type EventBaseWebBase = {
  baseType: string;
};
export type StatusWeb = "PLANNED" | "STARTED" | "COMPLETED" | "CANCELED";
export type UserInfoWeb = {
  userId: string;
  userName: string;
};
export type UnitActivityWeb = {
  id: string;
  unitId: number;
  startDateTime?: string;
  endDateTime?: string | null;
  status?: StatusWeb;
};
export type ParentTypeWeb = "Activity" | "Deviation";
export type CommentWeb = {
  id: string;
  partitionKey: string;
  parentId: string;
  parentPartitionKey: string;
  parentType: ParentTypeWeb;
  text?: string | null;
  createdBy?: UserInfoWeb;
  createdDateTime?: string;
  modifiedBy?: UserInfoWeb;
  modifiedDateTime?: string | null;
};
export type UnitFeedLossWeb = {
  id: string;
  feedLossPartitionKey?: string | null;
  parentId: string;
  parentPartitionKey?: string | null;
  dailyLogId: string;
  unitId?: number;
  dateTime?: string;
  amount?: number;
};
export type ActivityWeb = {
  baseType: "Activity";
} & EventBaseWebBase & {
    id: string;
    partitionKey: string;
    siteId: number;
    parentId: string | null;
    type: string;
    description?: string | null;
    status: StatusWeb;
    startDateTime?: string;
    endDateTime?: string | null;
    createdBy?: UserInfoWeb;
    createdDateTime?: string;
    modifiedBy?: UserInfoWeb;
    modifiedDateTime?: string | null;
    hasDeviatingSubEvents?: boolean;
    subEvents?: UnitActivityWeb[];
    comments?: CommentWeb[];
    feedLosses?: UnitFeedLossWeb[];
  };
export type ActivityUnitWebRequest = {
  id?: string | null;
  unitId: number;
  startDateTime?: string | null;
  endDateTime?: string | null;
};
export type ActivitySaveWebRequest = {
  id?: string | null;
  partitionKey?: string | null;
  siteId: number;
  type: string;
  startDateTime: string;
  endDateTime?: string | null;
  description?: string | null;
  subEvents?: ActivityUnitWebRequest[] | null;
};
export type ActivitySetStatusWebRequest = {
  id: string;
  partitionKey: string;
  dateTime?: string | null;
  unitIds?: number[] | null;
};
export type IotAggregateWeb = {
  dateTime?: string;
  averageValue?: number;
  minValue?: number;
  maxValue?: number;
  sum?: number;
  averageDepth?: number;
  count?: number;
  measurement?: string | null;
};
export type IotTypeAggregateWeb = {
  type: string;
  items: IotAggregateWeb[];
  latest: string | null;
  devices: string[];
};
export type IotUnitAggregateWeb = {
  unitId: number | null;
  items: IotTypeAggregateWeb[];
};
export type IotMultiUnitAggregateWeb = {
  siteId: number;
  items: IotUnitAggregateWeb[];
};
export type AggregateGetIotUnitWebRequest = {
  from: string;
  to: string;
  siteIds: number[];
  dataTypes?: string[] | null;
  unitIds?: number[] | null;
  bucketSize?: string | null;
};
export type IotMultiTypeAggregateWeb = {
  siteId: number;
  items: IotTypeAggregateWeb[];
};
export type SeverityWeb = "CRITICAL" | "MODERATE" | "MINIMAL";
export type UnitDeviationWeb = {
  id: string;
  unitId: number;
  startDateTime?: string;
  endDateTime?: string | null;
  resolved?: boolean;
  solution?: string | null;
  severity?: SeverityWeb;
};
export type DeviationWeb = {
  baseType: "Deviation";
} & EventBaseWebBase & {
    id: string;
    partitionKey: string;
    siteId?: number;
    parentId: string | null;
    type: string;
    severity: SeverityWeb;
    startDateTime?: string;
    endDateTime?: string | null;
    description?: string | null;
    solution?: string | null;
    createdBy?: UserInfoWeb;
    createdDateTime?: string;
    modifiedBy?: UserInfoWeb;
    modifiedDateTime?: string | null;
    resolved?: boolean;
    hasDeviatingSubEvents?: boolean;
    subEvents?: UnitDeviationWeb[];
    comments?: CommentWeb[];
    feedLosses?: UnitFeedLossWeb[];
  };
export type XRangeChartDataWeb = {
  x?: string;
  x2?: string;
  y?: number;
  title: string;
  type: string;
  eventId: string;
  document: ActivityWeb | DeviationWeb;
};
export type EventsXRangeChartWeb = {
  id: string;
  type: string;
  data?: XRangeChartDataWeb[];
};
export type SiteEventsChartWeb = {
  id: string;
  type: string;
  series?: EventsXRangeChartWeb[];
};
export type CommentCreateWebRequest = {
  text: string;
  siteId: number;
  parentId: string;
  parentPartitionKey: string;
  parentType: ParentTypeWeb;
};
export type CommentUpdateWebRequest = {
  id: string;
  partitionKey: string;
  siteId: number;
  text: string;
};
export type FeedPlanSourceWeb = "ManualPlan" | "FeedStation" | "Farmer";
export type FeedPlanSiteSettingsWeb = {
  siteId: number;
  source?: FeedPlanSourceWeb;
};
export type FeedPlanSettingsWeb = {
  sites: FeedPlanSiteSettingsWeb[];
};
export type CompanySettingsWeb = {
  id: string;
  partitionKey: string;
  feedPlanSettings?: FeedPlanSettingsWeb;
};
export type CompanySettingsSaveWebRequest = {
  feedPlanSettings: FeedPlanSettingsWeb;
};
export type UnitRatingWeb = {
  unitId?: number;
  rating?: number;
};
export type DailyLogWeb = {
  id: string;
  partitionKey: string;
  siteId: number;
  createdDateTime?: string;
  createdBy?: UserInfoWeb;
  subEvents?: (ActivityWeb | DeviationWeb)[];
  modifiedDateTime?: string | null;
  modifiedBy?: UserInfoWeb;
  description: string;
  shiftStartDateTime: string;
  shiftEndDateTime: string;
  rating?: UnitRatingWeb[];
};
export type UnitRatingWebRequest = {
  unitId: number;
  rating?: number;
};
export type UnitFeedLossWebRequest = {
  id?: string | null;
  amount: number;
  parentId: string;
  parentPartitionKey: string;
  parentType: ParentTypeWeb;
  unitId: number;
};
export type DailyLogSaveWebRequest = {
  id?: string | null;
  partitionKey?: string | null;
  siteId: number;
  description?: string | null;
  shiftStartDateTime?: string;
  shiftEndDateTime?: string;
  rating?: UnitRatingWebRequest[] | null;
  feedLosses?: UnitFeedLossWebRequest[] | null;
};
export type DeviationUnitWebRequest = {
  id?: string | null;
  unitId: number;
  startDateTime: string;
  endDateTime?: string | null;
  resolved?: boolean | null;
};
export type DeviationSaveWebRequest = {
  id?: string | null;
  partitionKey?: string | null;
  siteId: number;
  severity: SeverityWeb;
  type: string;
  startDateTime: string;
  endDateTime?: string | null;
  description?: string | null;
  subEvents?: DeviationUnitWebRequest[] | null;
  resolved?: boolean;
};
export type DeviationResolveWebRequest = {
  id: string;
  partitionKey: string;
  solution?: string | null;
  endDateTime?: string;
  unitIds: number[];
};
export type DeviceWeb = {
  companyId?: string;
  deviceId?: string;
  deviceName?: string;
  applicationType?: string;
};
export type FeedLossWeb = {
  id: string;
  partitionKey: string;
  siteId: number;
  unitId?: number;
  dailyLogId: string;
  amount?: number;
  dateTime?: string;
  createdBy?: UserInfoWeb;
  createdDateTime?: string;
  modifiedBy?: UserInfoWeb;
  modifiedDateTime?: string | null;
};
export type FeedPlanDetailsWeb = {
  date?: string;
  actualAmount?: number;
  plannedAmount?: number;
};
export type FeedPlanUnitPlanWeb = {
  unitId: number;
  plans: FeedPlanDetailsWeb[];
};
export type FeedPlanSitePlanWeb = {
  siteId: number;
  source: FeedPlanSourceWeb;
  units: FeedPlanUnitPlanWeb[];
};
export type FeedPlanUnitWebRequest = {
  unitId: number;
  amount?: number;
};
export type FeedPlanSaveWebRequest = {
  siteId: number;
  dateTime: string;
  units: FeedPlanUnitWebRequest[];
};
export type FeedPlanDayWeb = {
  date?: string;
  plannedAmount?: number;
};
export type FeedPlanUnitDailyWeb = {
  unitId?: number;
  plannedAmount?: number;
  feedPlanDays: FeedPlanDayWeb[];
};
export type FeedPlanDailyWeb = {
  siteId?: number;
  timeZone: string;
  fromDate?: string;
  toDate?: string;
  plannedAmount?: number;
  feedPlanUnits: FeedPlanUnitDailyWeb[];
  feedPlanDays: FeedPlanDayWeb[];
};
export type SiteUnitWeb = {
  siteId?: number;
  unitIds?: number[] | null;
};
export type FeedPlanGetDailyBySitesWebRequest = {
  sites: SiteUnitWeb[];
  fromDate?: string;
  toDate?: string;
};
export type FishtraceSlimProjectWeb = {
  siteId: number | null;
  farmerSiteId: number;
  projectName: string;
  projectId: number;
  generation: number;
};
export type FishtraceProjectWeb = {
  farmerSiteId: number;
  projectId: number;
  projectName: string;
  generation: number;
  active: boolean;
  modelId: number | null;
  yearClassId: number;
  stageId: number;
  speciesId: number;
  comment: string | null;
  m3ItemNumber: string | null;
  m3LotCode: string | null;
  m3ProjectCode: string | null;
  smoltTypeId: number | null;
  allowExportInFskpi: boolean | null;
  feedingTypeId: number | null;
  functionalFeedStrategyId: number | null;
  feedingStrategyId: number | null;
  siteId: number;
};
export type FishtraceProjectInfo = {
  projectId: number;
  projectCode: string;
};
export type FishtraceFarmerUnitInfo = {
  unitId: number;
  unitName: string;
};
export type FishtraceDuration = {
  from?: string | null;
  to?: string | null;
};
export type FishtraceHatchery = {
  projects: FishtraceProjectInfo[];
  fishgroups: string[];
  farmerUnits: FishtraceFarmerUnitInfo[];
  strippingTemp: number;
  incubationTemp: number;
  atu: number;
  spawned: number;
  eggBatches: string[];
  farmerSiteId: number | null;
  siteId: number | null;
  siteName: string;
  duration: FishtraceDuration;
};
export type FishtraceJuvenile = {
  projects: FishtraceProjectInfo[];
  fishgroups: string[];
  farmerUnits: FishtraceFarmerUnitInfo[];
  hatched: number;
  productionDays: number;
  avgHatcheryTemp: number;
  startWeight: number;
  bfcr: number;
  survivalRate: number;
  farmerSiteId: number | null;
  siteId: number | null;
  siteName: string;
  duration: FishtraceDuration;
};
export type FishtraceOngrowing = {
  projects: FishtraceProjectInfo[];
  fishgroups: string[];
  farmerUnits: FishtraceFarmerUnitInfo[];
  productionDays: number;
  startWeight: number;
  unitsUsed: number;
  treatments: number;
  bfcr: number;
  rgi: number;
  survivalRate: number;
  farmerSiteId: number | null;
  siteId: number | null;
  siteName: string;
  duration: FishtraceDuration;
};
export type FishtraceHarvest = {
  farmerUnits: FishtraceFarmerUnitInfo[] | null;
  harvests: number;
  netWeight: number;
  count: number;
  roundWeight: number;
  superior: number;
  farmerSiteId: number | null;
  siteId: number | null;
  siteName: string;
  duration: FishtraceDuration;
};
export type FishtraceTransport = {
  name: string;
  fromFarmerSiteId: number;
  toFarmerSiteId: number;
  projects: FishtraceProjectInfo[];
  farmerUnits: FishtraceFarmerUnitInfo[];
  duration: FishtraceDuration;
  speciesFao: string;
  speciesIds: number[];
  generationName: string;
  yearClassIds: string[];
  populationType: string[];
};
export type FishtraceWeb = {
  hatcheries: FishtraceHatchery[];
  juveniles: FishtraceJuvenile[];
  ongrowings: FishtraceOngrowing[];
  harvests: FishtraceHarvest[];
  transports: FishtraceTransport[];
};
export type FishtraceProjectRangeWeb = {
  startDate: string | null;
  endDate: string | null;
};
export type FishtraceFishgroupWeb = {
  farmerSiteId: number;
  fishgroupName: string;
  siteId: number;
  generation: number;
};
export type FishtraceSiteWeb = {
  siteId: number;
  companyId: string;
  siteCode: string | null;
  siteName: string;
  siteType: string;
  maxTotalBiomass: number;
  timezone: string;
  deleted: boolean;
  farmerCode: string;
  farmerSiteId: number;
  latitude: number | null;
  longitude: number | null;
  license: string | null;
};
export type FishtraceUnitWeb = {
  unitId: number;
  siteId: number;
  unitName: string;
  depth: number | null;
  seabed: number | null;
  unitShape: string | null;
  volume: number | null;
  width: number | null;
  latitude: number | null;
  longitude: number | null;
  unitCode: string | null;
  deleted: boolean;
  farmerUnitId: number | null;
  farmerSiteId: number | null;
};
export type HistoricalDataBucketWeb = {
  dateTime?: string;
  value?: number | null;
};
export type HistoricalDataDeviceWeb = {
  deviceId?: string;
  deviceName?: string;
  applicationType?: string;
  items?: HistoricalDataBucketWeb[];
};
export type HistoricalDataUnitWeb = {
  unitId?: number;
  items?: HistoricalDataBucketWeb[];
  devices?: HistoricalDataDeviceWeb[];
};
export type HistoricalDataSiteWeb = {
  siteId?: number;
  items?: HistoricalDataBucketWeb[];
  units?: HistoricalDataUnitWeb[];
};
export type HistoricalDataWeb = {
  avg?: number | null;
  max?: number | null;
  min?: number | null;
  dataType?: string | null;
  items?: HistoricalDataBucketWeb[];
  sites?: HistoricalDataSiteWeb[];
};
export type AggregationWeb = "All" | "Site" | "Unit" | "Device";
export type DepthFilterWeb = {
  depthFrom?: number | null;
  depthTo?: number | null;
};
export type InsightsGetHistoricWebRequest = {
  fromTime?: string;
  toTime?: string;
  sites: SiteUnitWeb[];
  dataType?: string | null;
  bucketSize?: string;
  aggregation?: AggregationWeb;
  depthFilter?: DepthFilterWeb;
};
export type ActionCountStatsWeb = {
  count?: number;
  durationMinutes?: number;
  feedLoss?: number;
};
export type InsightsGetCountStatsWebRequest = {
  fromTime?: string;
  toTime?: string;
  sites?: SiteUnitWeb[];
};
export type MealWeb = {
  siteId?: number;
  unitId?: number | null;
  startDateTime?: string;
  endDateTime?: string;
  feedAmount?: number;
  duration?: string;
  averageIntensity?: number;
};
export type SiteSettingsWeb = {
  siteId: number;
  isHidden?: boolean;
};
export type RealtimeSiteWeb = {
  id: number;
  hiddenPositions?: number[] | null;
};
export type RealtimeFilterWeb = {
  showNoData?: boolean;
  feedingOnly?: boolean;
  sites?: RealtimeSiteWeb[];
  siteAverage?: string;
  dataTypes?: string[] | null;
};
export type UserSettingsWeb = {
  id: string;
  partitionKey: string;
  sites: SiteSettingsWeb[];
  language: string;
  realtimeFilter: RealtimeFilterWeb;
};
export type UserSettingsSaveWebRequest = {
  sites: SiteSettingsWeb[];
  language?: string;
  realtimeFilter: RealtimeFilterWeb;
};
export const {
  usePostApiByCompanyIdActivityMutation,
  usePutApiByCompanyIdActivityMutation,
  useCompletedMutation,
  useCanceledMutation,
  useStartedMutation,
  useGetApiByCompanyIdActivityAndIdPartitionKeyQuery,
  useDeleteApiByCompanyIdActivityAndIdPartitionKeyMutation,
  useGetApiByCompanyIdActivityListQuery,
  usePostApiAggregateUnitMutation,
  usePostApiAggregateMultiTypeMutation,
  useGetApiByCompanyIdChartEventsQuery,
  useDeleteApiByCompanyIdCommentAndIdPartitionKeyMutation,
  useGetApiByCompanyIdCommentAndIdPartitionKeyQuery,
  usePostApiByCompanyIdCommentMutation,
  usePutApiByCompanyIdCommentMutation,
  usePatchApiByCompanyIdCompanySettingsMutation,
  useGetApiByCompanyIdCompanySettingsQuery,
  useGetApiByCompanyIdDailyLogAndIdPartitionKeyQuery,
  useDeleteApiByCompanyIdDailyLogAndIdPartitionKeyMutation,
  usePostApiByCompanyIdDailyLogMutation,
  usePutApiByCompanyIdDailyLogMutation,
  useDeleteApiByCompanyIdDailyLogMutation,
  useGetApiByCompanyIdDailyLogListQuery,
  usePostApiByCompanyIdDeviationMutation,
  usePutApiByCompanyIdDeviationMutation,
  usePatchApiByCompanyIdDeviationResolveMutation,
  useGetApiByCompanyIdDeviationAndIdPartitionKeyQuery,
  useDeleteApiByCompanyIdDeviationAndIdPartitionKeyMutation,
  useGetApiByCompanyIdDeviationListQuery,
  useGetApiByCompanyIdEquipmentDevicesQuery,
  useDeleteApiByCompanyIdFeedLossAndIdPartitionKeyMutation,
  useGetApiByCompanyIdFeedLossAndIdPartitionKeyQuery,
  usePutApiByCompanyIdFeedPlanMutation,
  useGetApiByCompanyIdFeedPlanListQuery,
  usePostApiByCompanyIdFeedPlanDayMutation,
  useGetApiByCompanyIdFishTraceProjectsQuery,
  useGetApiByCompanyIdFishTraceProjectAndProjectIdQuery,
  useGetApiByCompanyIdFishTraceAssembledContentAndPopulationIdQuery,
  useGetApiByCompanyIdFishTraceUnitsWithDataAndSiteIdDateQuery,
  useGetApiByCompanyIdFishTraceProjectRangeAndProjectIdQuery,
  useGetApiByCompanyIdFishTraceAssembledContentAndFarmerSiteIdUnitIdDateQuery,
  useGetApiByCompanyIdFishTraceAssembledProjectAndProjectIdDateQuery,
  useGetApiByCompanyIdFishTraceAssembledSiteAndFarmerSiteIdDateQuery,
  useGetApiByCompanyIdFishTraceAssembledUnitAndFarmerUnitIdDateQuery,
  useGetApiByCompanyIdFishTraceFishgroupsQuery,
  useGetApiByCompanyIdFishTraceFishgroupsAndGenerationQuery,
  useGetApiByCompanyIdFishTraceSitesQuery,
  useGetApiByCompanyIdFishTraceUnitsQuery,
  usePostApiByCompanyIdInsightsHistoricalDataMutation,
  usePostApiByCompanyIdInsightsActivitiesStatsMutation,
  usePostApiByCompanyIdInsightsDeviationsStatsMutation,
  useGetApiMealListQuery,
  usePutApiByCompanyIdUserSettingsMutation,
  useGetApiByCompanyIdUserSettingsQuery,
} = injectedRtkApi;

import { knowledgerApi } from "./knowledgerApi";
export type knowledgerApiType = typeof knowledgerApi;
